// STAGING-omgeving voor de beheer-app (siq_adminapp).
// Wordt over src/environments/environment.ts gemount. Praat met dezelfde
// auth + api als de gewone webapp. URL's zijn in de frontend ingebakken.
export const environment = {
  production: false,
  envName: 'prod' as 'dev' | 'prod' | 'china',
  authUrl: 'https://auth.playstats.ai',
  apiUrl: 'https://api.playstats.ai',
  dispatchUrl: 'https://dispatch.playstats.ai',
  storageUrl: 'https://api.playstats.ai/storage/',
  // De gewone webomgeving. Het wijzigen van je wachtwoord loopt daar: de
  // beheerconsole heeft geen eigen wachtwoordscherm.
  //
  // LET OP: dit bestand wordt over src/environments/environment.ts gemount.
  // Een veld dat alleen in src/environments/ staat bestaat op de server dus
  // NIET, en dan valt `ng serve` om en geeft de console 404 — zonder dat de
  // container "down" lijkt. Dat is nu drie keer gebeurd (17-08 en 18-08).
  // Voeg een nieuw veld dus ALTIJD op beide plekken toe.
  webAppUrl: 'https://app.playstats.ai'
};
